<template lang="pug">
  .color-solutions-more-options-modal(v-if="selectedColor && selectedColor.id")
    try-it-on(:compare-product-id="selectedColor.id" @select="changeColor" @cancel="hideModal")
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';

  export default {
    name: "ColorSolutionsMoreOptionsModal",

    computed: {
      ...mapState('moreColorOptions', ['selectedColor'])
    },

    methods: {
      ...mapMutations('moreColorOptions', ['setSelectedColor']),

      ...mapActions('modal', 'hideModal'),

      changeColor(product) {
        this.setSelectedColor(product);
        this.hideModal();
      }
    }
  }  
</script>

<style scoped lang="stylus">
  
</style>
